import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { CustomerInfo } from '../../components/customer-info';
import MapContainer from '../../../Map/containers/MapContainer';
import NOB from '../../../../constants/language-strings';
import { TechnicalDetails } from '../../components/technical-details/technical-details';
import { SCHEDULED_ACTIVATION, WAITING_ACTIVATION } from '../../../../constants/productStatuses';
import UNAUTHORIZED from '../../../../constants/errorStatusCodes';
import NavigationButton from '../../../../components/Buttons/NavigationButton/navigation-button';
import { CUSTOMER_INFO_ADDRESS_HISTORY_URL, CUSTOMER_INFO_CUSTOMER_PRODUCTS_URL, CUSTOMER_INFO_HEALTH_CHECK_URL, } from '../../../../constants/paths';
import { Icon } from '@purpurds/purpur/icon';
import { icons } from 'theme/icons';
import { Loader, PurPurButton } from 'components';
import styled from 'styled-components';
import { purpurColorPurple800 } from '@purpurds/tokens/color/variables';
import { useCustomerInfoPage } from 'modules/Workorder/api/use-customer-info-page';
import { ErrorNotification } from 'components/error-notification';
import { Modal } from 'components/modal';
import { GoogleMapsButton } from 'modules/Workorder/components/customer-info';
const mapContainerHeight = `calc(320px + 66px)`;
const WorkOrderContainer = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;
const WorkOrderContent = styled.div `
  display: flex;
  flex-direction: column;
  justify-content: stretch;
  width: 100%;
  min-width: 320px;
  max-width: 750px;
  position: relative;

  @media (min-width: 750px) {
    width: 750px;
  }
`;
const WorkOrderContentTop = styled.div `
  height: calc(100% + ${mapContainerHeight});
  padding-bottom: ${mapContainerHeight};
`;
const CustomerInfoContainer = styled.div `
  display: block;
  width: 100%;
  margin-bottom: 5px;
  margin-top: 0.5rem;
`;
const StyledIcon = styled(Icon) `
  color: ${purpurColorPurple800};
`;
const ButtonWrapper = styled.div `
  display: flex;
  justify-content: center;
  gap: 1rem;
`;
export const CustomerPage = ({ customerId = 0 }) => {
    var _a, _b;
    const [googleMapsModalOpen, setGoogleMapsModalOpen] = useState(null);
    const { workOrderByCustomerId, addressHistory, customerProducts, isLoading, workOrderByCustomerIdErrorMessage, } = useCustomerInfoPage(customerId);
    const waitingActivationsLength = customerProducts.filter((waitingActivation) => waitingActivation.status === WAITING_ACTIVATION ||
        waitingActivation.status === SCHEDULED_ACTIVATION).length;
    const newWorkOrderEntered = !(workOrderByCustomerId === null || workOrderByCustomerId === void 0 ? void 0 : workOrderByCustomerId.customer.customerId) || `${workOrderByCustomerId.customer.customerId}` !== String(customerId);
    const noAccess = workOrderByCustomerIdErrorMessage === null || workOrderByCustomerIdErrorMessage === void 0 ? void 0 : workOrderByCustomerIdErrorMessage.includes(UNAUTHORIZED);
    if (isLoading && !workOrderByCustomerIdErrorMessage) {
        return _jsx(Loader, {});
    }
    if (workOrderByCustomerIdErrorMessage) {
        return (_jsx(ErrorNotification, { title: NOB.FEEDBACKS.SORRY, link: noAccess, text: noAccess ? NOB.NO_WORK_ORDERS.NO_ACCESS : workOrderByCustomerIdErrorMessage }));
    }
    if (!workOrderByCustomerId || workOrderByCustomerId.workOrderId === 0) {
        return (_jsx(ErrorNotification, { title: NOB.FEEDBACKS.SORRY, link: true, text: "Unable to retrieve work order information. Try to refresh browser or login again." }));
    }
    return (_jsx(WorkOrderContainer, { children: _jsxs(WorkOrderContent, { children: [_jsxs(WorkOrderContentTop, { children: [_jsx(CustomerInfoContainer, { children: _jsx(CustomerInfo, { address: workOrderByCustomerId.address, addressDetails: workOrderByCustomerId.addressDetails, customer: workOrderByCustomerId.customer, openModal: (address) => setGoogleMapsModalOpen(address), workOrder: workOrderByCustomerId }) }), addressHistory.length > 0 && (_jsx(NavigationButton, { URL: CUSTOMER_INFO_ADDRESS_HISTORY_URL(customerId), id: (_a = workOrderByCustomerId === null || workOrderByCustomerId === void 0 ? void 0 : workOrderByCustomerId.address) === null || _a === void 0 ? void 0 : _a.validAddressId, leftIcon: _jsx(StyledIcon, { svg: icons.summary }), title: NOB.WORKORDER_TABS.ADDRESS_HISTORY, number: addressHistory.length })), _jsx(NavigationButton, { URL: CUSTOMER_INFO_CUSTOMER_PRODUCTS_URL(customerId), id: customerId, title: NOB.CUSTOMER_PRODUCTS.CUSTOMER_PRODUCTS, leftIcon: _jsx(StyledIcon, { svg: icons.box }), number: waitingActivationsLength > 0 ? waitingActivationsLength : null }), _jsx(NavigationButton, { URL: CUSTOMER_INFO_HEALTH_CHECK_URL(customerId), leftIcon: _jsx(StyledIcon, { svg: icons.pulse }), title: NOB.HEALTH_CHECK.HEALTH_CHECK }), _jsx(TechnicalDetails, { technicalDetails: workOrderByCustomerId.technicalDetails, capacity: (_b = workOrderByCustomerId === null || workOrderByCustomerId === void 0 ? void 0 : workOrderByCustomerId.capacity) === null || _b === void 0 ? void 0 : _b.data })] }), !!googleMapsModalOpen && (_jsx(Modal, { title: NOB.GOOGLE_MAPS_POPUP.GOOGLE_MAPS, isOpen: !!googleMapsModalOpen, onClose: () => setGoogleMapsModalOpen(null), style: 'info', actionButtons: _jsxs(ButtonWrapper, { children: [_jsx(PurPurButton, { variant: "secondary", onClick: () => setGoogleMapsModalOpen(null), children: "Cancel" }), _jsx(GoogleMapsButton, { onClose: () => setGoogleMapsModalOpen(null), address: workOrderByCustomerId.address })] }), children: NOB.GOOGLE_MAPS_POPUP.QUESTION })), _jsx(MapContainer, { newWorkOrderEntered: newWorkOrderEntered, customerAddress: workOrderByCustomerId.address, technicalDetails: workOrderByCustomerId.technicalDetails })] }) }));
};
